<template>
    <UserProfile />

    <main class="min-h-screen bg-[#fafafa] flex flex-col items-center pt-24 px-6">

        <TheClock class="mb-10" />

        <SearchBar class="mb-14" />

        <NavGrid />

        <EdgePanel label="CALENDAR" width="420px">
            <CalendarTool />
        </EdgePanel>

        <TheToast :visible="visible" :message="message" :type="type" />

    </main>
</template>

<script setup>
import TheToast from './components/common/TheToast.vue';
import { useToast } from './utils/toast';
import UserProfile from './components/UserProfile.vue';
import TheClock from './components/TheClock.vue';
import SearchBar from './components/SearchBar.vue';
import NavGrid from './components/NavGrid.vue';
import EdgePanel from './components/EdgePanel.vue';
import CalendarTool from './components/tools/CalendarTool.vue';

const { visible, message, type } = useToast();

</script>

<style>
/* 针对所有 Webkit 内核浏览器 (Chrome, Safari, Edge, 新版 Opera) */

/* 1. 滚动条整体部分 */
::-webkit-scrollbar {
    width: 6px;
    /* 纵向滚动条宽度 */
    height: 6px;
    /* 横向滚动条高度 */
}

/* 2. 滚动条轨道 */
::-webkit-scrollbar-track {
    background: transparent;
}

/* 3. 滚动条滑块 (Thumb) */
::-webkit-scrollbar-thumb {
    background: #e5e7eb;
    border-radius: 10px;
    /* 增加一个透明边框可以实现滑块与轨道之间的间距感 */
    border: 1px solid transparent;
    background-clip: content-box;
}

/* 4. 滑块悬停状态 */
::-webkit-scrollbar-thumb:hover {
    background: #1E90FF;
    /* 使用你定义的道奇蓝 */
}

/* 针对 Firefox 的兼容性优化 (Firefox 不支持 webkit 伪类) */
* {
    scrollbar-width: thin;
    scrollbar-color: #e5e7eb transparent;
}

</style>